export default __webpack_public_path__ + "static/media/simplyhired.16fac4d2.webp";